module.exports = require('../dist/contexts/DisplayPageContext');
